import { render, staticRenderFns } from "./DagDemo.vue?vue&type=template&id=576e1410&scoped=true"
import script from "./DagDemo.vue?vue&type=script&lang=js"
export * from "./DagDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576e1410",
  null
  
)

export default component.exports